<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { ProjectUser } from '@Projects/Model';
    import { guid } from '@common/Guid';
    import { ProjectUsersFromStringBuilderViewModel } from '@ProjectUsers/Components/ProjectUsersFromStringBuilder';
    import { isNullOrWhitespace } from "@common/Common";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class ProjectUsersFromStringBuilder extends Vue
    {
        get vm(): ProjectUsersFromStringBuilderViewModel { return this.$props.viewModel as ProjectUsersFromStringBuilderViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get operationInProgress(): boolean { return this.vm.operationInProgress; } 
        get tags(): string[] { return this.vm.tags; }

        get step(): number { return this.vm.step; }
        set step(val: number) { return this.vm.step = val; } 
        
        NamesOrEmails: string | null = null;
        ProjectUsers: ProjectUserVM[] = [];
        
        preview()
        {
            if (this.NamesOrEmails)
            {
                let lines = this.NamesOrEmails.split(/\r\n|\r|\n/g);

                if (lines && lines.length > 0)
                {
                    this.ProjectUsers = [];

                    for (let line of lines)
                    {
                        if (line)
                        {
                            if (line.indexOf("\t") > -1)
                            {
                                let parts = line.split("\t");
                                let part1 = parts[0];
                                let part2 = parts[1];

                                const tagsStr = parts.length === 3 ? parts[2] : null;
                                let tags = isNullOrWhitespace(tagsStr) ? null : tagsStr.split(';').map(a => a.trim()).filter(a => !isNullOrWhitespace(a));

                                if (tags)
                                {
                                    tags = tags.filter(a => this.tags.indexOf(a) > -1);
                                }


                                if (part1.indexOf("@") > -1)
                                {
                                    this.ProjectUsers.push(ProjectUserVM.Create(part2, part1, tags));
                                }
                                else if (part2.indexOf("@") > -1)
                                {
                                    this.ProjectUsers.push(ProjectUserVM.Create(part1, part2, tags));
                                }
                                else
                                {
                                    this.ProjectUsers.push(ProjectUserVM.Create(line, null, tags));
                                }
                            }
                            else
                            {
                                this.ProjectUsers.push(ProjectUserVM.Create(line, line.indexOf("@") > -1 ? line : null, null));
                            }
                        }
                    }

                    this.step = 2;
                }
            }
        }

        back()
        {
            this.step = 1;
        }

        handleCreateProjectUsers()
        {
            const projectUsers = this.ProjectUsers.filter(a => a.Name).map(a => a.GetData());

            this.vm.operationInProgress = true;
            this.ProjectUsers = [];
            this.NamesOrEmails = [];

            this.$emit("create-project-users", projectUsers);
        }

        close()
        {
            this.vm.close();
        }
    }

    class ProjectUserVM
    {
        LocalId: string;
        Name: string = null;
        Email: string = null;
        Tags: string[] = null;

        private constructor(name: string, email: string, tags: string[], localId: string)
        {
            this.Name = name;
            this.Email = email;
            this.LocalId = localId;
            this.Tags = tags;
        }

        static Create(name: string, email: string, tags: string[]): ProjectUserVM
        {
            return new ProjectUserVM(name, email, tags, guid());
        }

        GetData(): ProjectUser
        {
            const pu = new ProjectUser();
            pu.ProjectUserId = 0;
            pu.LocalId = this.LocalId;
            pu.Name = this.Name;
            pu.Email = this.Email;
            pu.Tags = this.Tags;
            return pu;
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div v-if="step === 1">
                            <div style="overflow-x: hidden;">
                                <label>Insert as many respondent names as you like, with each on a new line</label>
                                <textarea v-model.trim="NamesOrEmails" class="form-control" rows="8" placeholder="you can copy and paste here"></textarea>
                            </div>
                        </div>

                        <div v-if="step === 2">
                            <div class="row" style="margin-bottom: 3px;" v-for="p in ProjectUsers" :key="p.LocalId">
                                <div class="col-md-4">
                                    <input type="text" v-model.trim="p.Name" class="form-control" placeholder="Required name">
                                </div>

                                <div class="col-md-4">
                                    <input type="email" v-model.trim="p.Email" class="form-control" placeholder="Optional email">
                                </div>

                                <div class="col-md-4">
                                    <span class="badge badge-secondary" v-for="t in p.Tags" :key="t">{{t}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button v-if="step === 1" @click="preview" class="btn btn-primary">Preview</button>

                        <button v-if="step === 2" @click="back" class="btn btn-outline-secondary" :disabled="operationInProgress">Back</button>

                        <button v-if="step === 2" @click="handleCreateProjectUsers" :disabled="operationInProgress" type="button" class="btn btn-primary">
                            <span v-if="operationInProgress"><i class="fa fa-spinner fa-spin"></i> Please wait...</span>
                            <span v-if="!operationInProgress">Save</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>